module.exports = __webpack_public_path__ + "static/media/skeleton.8b269bf0.svg";